import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "w-100 mb-3",
  open: ""
}
const _hoisted_2 = { class: "text-start" }
const _hoisted_3 = { class: "d-inline fs-4" }
const _hoisted_4 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("details", _hoisted_1, [
    _createElementVNode("summary", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ckeditor, {
        "model-value": _ctx.modelValue,
        editor: _ctx.editor,
        config: _ctx.editorConfig,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      }, null, 8, ["model-value", "editor", "config"])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}